(function () {
  'use strict';

  /* @ngdoc object
   * @name myMemberships.joinPod
   * @description
   *
   */
  angular
    .module('myMemberships.joinPod', [
      'ui.router'
    ]);
}());
